import styles from "./borrowingCapacityApllicantInfo1.module.css";
import CurrencyInput from "react-currency-input-field";

const BorrowingCapacityApllicantInfo1 = ({
  numberOfApplicants,
  onNumberOfApplicantsChange,
  numberOfDependant,
  dependants,
  onNumberOfDependantChange,
  rate,
  onRateChange,
  year,
  years,
  onYearsChange,
  annualIncome1,
  annualIncome2,
  onAnnualIncome1,
  onAnnualIncome2,
}) => {
  return (
    <>
      {/* 📌 Step 1 Heading + Divider */}
      <h2 className={styles.heading}>Step 1 of 2 </h2>
      <hr className={styles.divider} /> {/* Horizontal Line */}

      <div className={`col-m-6 ${styles.applicants_wrapper}`}>
        <button
          className={`${styles.btn} ${
            numberOfApplicants === 1 ? styles.btn_selected : styles.btn_unselected
          }`}
          name="numberOfApplicants"
          id="singleApplication"
          onClick={() => onNumberOfApplicantsChange(1)}
        >
          Single applicant
        </button>
        <button
          className={`${styles.btn} ${
            numberOfApplicants === 2 ? styles.btn_selected : styles.btn_unselected
          }`}
          name="numberOfApplicants"
          id="jointApplication"
          onClick={() => onNumberOfApplicantsChange(2)}
        >
          Joint application
        </button>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>
          Number of dependants (under the age of 18)
        </label>
        <select
          id="bcDependants"
          onChange={(event) => onNumberOfDependantChange(event.target.value)}
          className="form-select"
          defaultValue={numberOfDependant}
        >
          {dependants.sort((a, b) => a - b).map((value) => (
            <option key={value} value={value}>{value}</option>
          ))}
        </select>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Based on our lowest rate / Input your own rate</label>
        <div className={styles.flex_wrapper}>
          <input
            id="bcRate"
            type="number"
            step={0.01}
            min={0}
            onChange={(event) => onRateChange(event.target.value)}
            className={`form-control ${styles.rate_holder}`}
            defaultValue={rate}
          />
          <span className={styles.labeld1}>%</span>
        </div>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Loan Term</label>
        <select
          id="bcYears"
          onChange={(event) => onYearsChange(event.target.value)}
          className="form-select"
          defaultValue={year}
        >
          {years.sort((a, b) => b - a).map((value) => (
            <option key={value} value={value}>{value} years</option>
          ))}
        </select>
      </div>

      <div className="col-m-6">
        <label className={`form-label ${styles.label}`}>Applicant 1 income</label>
        <div className={styles.flex_wrapper}>
          <span className={styles.labeld}>$</span>
          <CurrencyInput
            className={`form-control ${styles.money_input}`}
            id="bcIncome1"
            defaultValue={annualIncome1}
            decimalsLimit={2}
            onValueChange={(value) => onAnnualIncome1(value)}
          />
        </div>
      </div>

      {numberOfApplicants === 2 && (
        <div className="col-m-6">
          <label className={`form-label ${styles.label}`}>Applicant 2 income</label>
          <div className={styles.flex_wrapper}>
            <span className={styles.labeld2}>$</span>
            <CurrencyInput
              className={`form-control ${styles.money_input}`}
              id="bcIncome2"
              defaultValue={annualIncome2}
              decimalsLimit={2}
              onValueChange={(value) => onAnnualIncome2(value)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BorrowingCapacityApllicantInfo1;
